/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCatalogModifierGroupRequestModifiersInner
 */
export interface UpdateCatalogModifierGroupRequestModifiersInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateCatalogModifierGroupRequestModifiersInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCatalogModifierGroupRequestModifiersInner
     */
    organizationModifierId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCatalogModifierGroupRequestModifiersInner
     */
    modifierGroupId: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCatalogModifierGroupRequestModifiersInner
     */
    priceImpact: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCatalogModifierGroupRequestModifiersInner
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCatalogModifierGroupRequestModifiersInner
     */
    catalogId: string;
}

/**
 * Check if a given object implements the UpdateCatalogModifierGroupRequestModifiersInner interface.
 */
export function instanceOfUpdateCatalogModifierGroupRequestModifiersInner(value: object): value is UpdateCatalogModifierGroupRequestModifiersInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationModifierId' in value) || value['organizationModifierId'] === undefined) return false;
    if (!('modifierGroupId' in value) || value['modifierGroupId'] === undefined) return false;
    if (!('priceImpact' in value) || value['priceImpact'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('catalogId' in value) || value['catalogId'] === undefined) return false;
    return true;
}

export function UpdateCatalogModifierGroupRequestModifiersInnerFromJSON(json: any): UpdateCatalogModifierGroupRequestModifiersInner {
    return UpdateCatalogModifierGroupRequestModifiersInnerFromJSONTyped(json, false);
}

export function UpdateCatalogModifierGroupRequestModifiersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCatalogModifierGroupRequestModifiersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationModifierId': json['organizationModifierId'],
        'modifierGroupId': json['modifierGroupId'],
        'priceImpact': json['priceImpact'],
        'enabled': json['enabled'],
        'catalogId': json['catalogId'],
    };
}

export function UpdateCatalogModifierGroupRequestModifiersInnerToJSON(json: any): UpdateCatalogModifierGroupRequestModifiersInner {
    return UpdateCatalogModifierGroupRequestModifiersInnerToJSONTyped(json, false);
}

export function UpdateCatalogModifierGroupRequestModifiersInnerToJSONTyped(value?: UpdateCatalogModifierGroupRequestModifiersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizationModifierId': value['organizationModifierId'],
        'modifierGroupId': value['modifierGroupId'],
        'priceImpact': value['priceImpact'],
        'enabled': value['enabled'],
        'catalogId': value['catalogId'],
    };
}

